import { render, staticRenderFns } from "./pcPageV2.vue?vue&type=template&id=b20188d8&scoped=true&"
import script from "./pcPageV2.vue?vue&type=script&lang=js&"
export * from "./pcPageV2.vue?vue&type=script&lang=js&"
import style0 from "./pcPageV2.vue?vue&type=style&index=0&id=b20188d8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b20188d8",
  null
  
)

export default component.exports